import { useCallback } from "react";
import { useAsync } from "@shared/hooks";
import { legacyHttpClient } from "@services/http/legacyHttpClient";

export interface Faq {
  id: number;
  question: string;
  answer: string;
  orderNum: number;
}

/**
 * Hook to fetch the list of FAQs from the CMS API.
 * GET /rest/api/web/cms/faqs
 */
export function useFaqs() {
  const fetcher = useCallback(
    () => legacyHttpClient.get<Faq[]>("/api/web/cms/faqs"),
    [],
  );

  return useAsync<Faq[]>(fetcher);
}
